import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";

function AbonosMaquilerosDefectosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [ano, setAno] = useState(date.getFullYear());
  const [semana, setSemana] = useState(moment(date).week());
  const [concepto, setConcepto] = useState("Abono");

  const [selectedBanco, setSelectedBanco] = useState("62dec0c3b05cd629f4ff7b44");
  const [bancos, setBancos] = useState([]);

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  // const [importeAplicar, setImporteAplicar] = useState(0);
  // const [saldoAplicar, setSaldoAplicar] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const formasPago = ["Defecto"];
  const [inputFields, setInputFields] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let proveedoresActivos = response.data.filter(
          (p) => p.is_active === "Si"
        );
        setProveedores(proveedoresActivos);

        // Inicializamos inputFields vacío con proveedores x formasPago
        const inicial = [];
        proveedoresActivos.forEach((prov) => {
          formasPago.forEach((fp) => {
            inicial.push({
              proveedorId: prov._id,
              formaPago: fp,
              importe: 0,
            });
          });
        });
        setInputFields(inicial);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });
  
  }, []);

  const handleChangeInputImporte = (value, proveedorId, formaPago) => {
    setInputFields((prev) =>
      prev.map((f) =>
        f.proveedorId === proveedorId && f.formaPago === formaPago
          ? { ...f, importe: parseFloat(value || 0) }
          : f
      )
    );
  };

  const handleChangeInputObservaciones = (value, proveedorId) => {
  setInputFields((prev) =>
    prev.map((f) =>
      f.proveedorId === proveedorId
        ? { ...f, observaciones: value }
        : f
    )
  );
};

  // Calcular total de todos los pagos
  const totalGeneral = inputFields.reduce((acc, curr) => acc + (curr.importe || 0), 0);


  // function ActualizaTotales() {
  //   let TEfe = inputFields.map((c) => parseFloat(c.importe));
  //   let TE = TEfe.reduce((t, total, index) => t + total, 0);

  //   setTotal(TE);

  //   // setSaldoAplicar(importeAplicar - TE);
  // }
// console.log("hola", inputFields)
function savePago() {
  if (selectedBanco !== "") {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Se registrará el abono",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();

        let totalMails = inputFields.length;

        inputFields.map((a) => {
          if (a.importe > 0) {
            axios
              .post(
                URL_ABONOS_PROVEEDORES,
                {
                  fecha,
                  importe: parseFloat(a.importe),
                  proveedores: a.proveedorId,
                  bancos: selectedBanco,
                  observaciones: a.observaciones,
                  codigoAgrupado,
                  editado: "No",
                  concepto,
                  formaPago: a.formaPago,
                  semana,
                  ano
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalMails = totalMails - 1;
                if (totalMails === 0) {
                  Swal.fire("Éxito", "Abonos creados con éxito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Algo salió mal",
                });
                console.error(error);
              });
          } else {
            totalMails = totalMails - 1;
          }
        });
      }
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Debes completar todo el formulario",
    });
  }
}


  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  // helpers
const pad2 = (n) => String(n).padStart(2, "0");
const toWeekInputValue = (y, w) => `${y}-W${pad2(w)}`;

console.log("hola", ano, semana, fecha)
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_adminCxP ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago por Defecto</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                {/* <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col> */}
                <Col md={2}>
                  <Label className="mr-sm-2">Semana</Label>
                  <Input
                    type="week"
                    value={toWeekInputValue(ano, semana)} // ej: "2025-W35"
                    onChange={(e) => {
                      // e.g. "2025-W35"
                      const [yStr, wStr] = e.target.value.split("-W");
                      const isoYear = parseInt(yStr, 10);
                      const week = parseInt(wStr, 10);

                      // Viernes de esa semana ISO, en UTC para evitar desfases
                      const friday = moment
                        .utc()
                        .isoWeekYear(isoYear)
                        .isoWeek(week)
                        .isoWeekday(5) // 1=lunes ... 5=viernes
                        .format("YYYY-MM-DD");

                      setAno(isoYear);
                      setSemana(week);
                      setFecha(friday); // "YYYY-MM-DD"
                    }}
                  />
                </Col>

                {/*    <Col md={3}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedProveedor) => {
                      if (selectedProveedor) {
                        setValue(selectedProveedor);
                        setSelectedProveedor(selectedProveedor._id);
                        setSelectedProveedorNombre(
                          selectedProveedor.nombre_comercial
                        );
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>


                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      setSelectedBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col> 

                <Col md={5}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                    </Badge>
                  </h4>
                </Col>*/}
              </Row>
              <br />
              {/* <Row>
                <Col md={1}>
                  <Label>Importe Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={importeAplicar}
                    className={`form-control`}
                    onValueChange={(value, name) => IA(value)}
                  />
                </Col>
                <Col md={1}>
                  <Label>Saldo Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={saldoAplicar}
                    className={`form-control`}
                    disabled
                  />
                </Col>
              </Row>
              <br /> */}
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
<Table striped borderless>
  <thead>
    <tr>
      <th>Proveedor</th>
      <th>Monto</th>
      <th>Observaciones</th>
    </tr>
  </thead>
  <tbody>
    {proveedores.map((prov) => {
      const totalProveedor = inputFields
        .filter((f) => f.proveedorId === prov._id)
        .reduce((acc, curr) => acc + (curr.importe || 0), 0);

      return (
        <tr key={prov._id}>
          <td>{prov.nombre_comercial}</td>
          {formasPago.map((fp) => {
            const registro = inputFields.find(
              (f) => f.proveedorId === prov._id && f.formaPago === fp
            );
            return (
              <td key={fp}>
                <CurrencyInput
                  intlConfig={{ locale: "en-US", currency: "USD" }}
                  prefix="$"
                  decimalsLimit={2}
                  value={registro?.importe || 0}
                  className="form-control"
                  onValueChange={(value) =>
                    handleChangeInputImporte(value, prov._id, fp)
                  }
                />
              </td>
            );
          })}

          {/* Campo de Observaciones */}
          <td>
            <input
              type="text"
              className="form-control"
              value={
                inputFields.find((f) => f.proveedorId === prov._id)?.observaciones || ""
              }
              onChange={(e) =>
                handleChangeInputObservaciones(
                  e.target.value,
                  prov._id
                )
              }
            />
          </td>

          <td>
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalProveedor)}
          </td>
        </tr>
      );
    })}

    <tr>
      <td
        className="negrita"
        align="center"
        colSpan={formasPago.length + 2} // +1 de Observaciones
      >
        Total General
      </td>
      <td className="negrita">
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(totalGeneral)}
      </td>
    </tr>
  </tbody>
  <br />
</Table>


                {/* Termina tabla cargos */}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                href="/ListadoAbonosMaquileros"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosMaquilerosDefectosCreate;
